export default __webpack_public_path__ + "static/media/signal conditioner.f2d137b3.jpg";